/**
 * Created by matheusmorett on 9/12/17.
 */
import React, {Component} from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import LazyLoad from 'react-lazy-load';
import { Link } from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import ReactGA from 'react-ga';
import NumberFormat from 'components/NumberFormat';
import {Grid, GridItem} from 'components/Grid';
import Breadcrumb from 'components/Breadcrumb';
import { Button, Icon, IconButton  } from '@material-ui/core';
import AdventureHeader from "components/AdventureHeader";
import AdventureGallery from "components/AdventureGallery";
import StarRatingComponent from 'react-star-rating-component';
import Tabs, { TabPane } from 'rc-tabs';
import 'rc-tabs/assets/index.css';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import Checkout from './../Checkout';
import moment from 'moment';
import Utils from 'utils/Utils';
import SimpleReactLightbox from "simple-react-lightbox";

import "./AdventureInfos.scss";

export const GoogleMaps = withScriptjs(withGoogleMap(props => (
    <GoogleMap
        defaultZoom={12}
        defaultCenter={props.defaultCenter}
    >
        <Marker
            {...props.circle}
            options={{
                fillColor: "#f50673",
                fillOpacity: .4,
                strokeColor: "#f50673",
                strokeWeight: 2
            }}
        />
    </GoogleMap>
)));

@inject('RequestStore', 'ApplicationStore', 'AuthStore')
@observer
class AdventureInfos extends Component {

    static defaultProps = {
        goToPayment: () => {},
        goToIGo: () => {},
        openLightbox: () => {},
        setFavorite: () => {},
        unsetFavorite: () => {},
    };

    constructor(props) {
        super(props);

        this.state = {
            tabActive: {
                descricao: true,
            },
            loadMapa: false,
            loadMeeting: false,
            seeMore: false,
            showLocal: false,
            includeOpen: false,
            localizationOpened: false,
            aboutTheOperatorOpened: false,
            whyLiveThisExperienceOpened: false,
            whatsNearbyOpened: false,
            otherRulesOpened: false,
            whatToKnowOpened: false,
            whatDoesNotIncludeOpened: false,
            whatToWearOpened: false,
            whatToTakeOpened: false,
            requirementsOpened: false,
            faqOpened: false,
            packagesOpened: []
        };

        this.handleGoTo = this.handleGoTo.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.onChangeTab = this.onChangeTab.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
    }

    handleGoTo(id) {
        const offsetTop = (this[id].offsetTop === 0) ? 141 : this[id].offsetTop;
        if (document.body.clientWidth > 768) {
            window.scrollTo({
                'behavior': 'smooth',
                'left': 0,
                'top': offsetTop - 850 + this.adventureInfos.offsetTop
            });
        }
    }

    onChangeTab() {

    }

    handleShowModal() {
        this.setState({
            showLocal: true
        });
        ReactGA.event({
            category: 'Local da Aventura',
            action: 'click',
            label: 'Mostrar local empresa'
        });
    }

    handleTogglePackage(pkPackage) {
        let { packagesOpened } = this.state;

        if(packagesOpened.includes(pkPackage)) {
            const index = packagesOpened.findIndex(po => po === packagesOpened);
            packagesOpened.splice(index, 1);
        } else {
            packagesOpened.push(pkPackage);
        }

        this.setState({
            packagesOpened
        })
    }

    getCommentDateFormat(date) {
        return moment(date).fromNow();
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll.bind(this));
        this.handleScroll();
    }

    componentWillUnmount() {
        Utils.addBodyScroll();
        window.removeEventListener('scroll', this.handleScroll.bind(this));
    }


    // LazyLoad Mapas
    handleScroll(e){
        // Se a bottom da pagina esta proximo do mapa. Carrega
        
        if (this.map && (this.map.getBoundingClientRect().y - (window.pageYOffset + window.innerHeight)) < 200 && !this.state.loadMapa) {
            this.setState({loadMapa: true});
        }
    }

    handleFavorite() {

        if (this.props.AuthStore.isLogged) {
            const params = {
                fk_user: this.props.AuthStore.authUser.pk_user,
                fk_adventure: this.props.Adventure.pk_adventure
            };
            if (!this.props.Adventure.favorite) {
                this.props.setFavorite(params);
            } else {
                this.props.unsetFavorite(params);
            }
        } else {
            this.props.ApplicationStore.openModalLogin();
        }

    }

    render() {
        if (this.props.Adventure !== undefined) {
            const { Adventure, RequestStore, ApplicationStore, AuthStore } = this.props;
            const { localizationOpened, packagesOpened } = this.state;
            return (
                <div ref={el => this.adventureInfos = el} id="Adventure-infos" className="AdventureInfos wrapper">
                    <div className="adventure">
                        <AdventureHeader 
                            Adventure={Adventure}
                            RequestStore={RequestStore}
                            ApplicationStore={ApplicationStore}
                            isLogged={AuthStore.isLogged}
                            authUser={AuthStore.authUser}
                        />

                        <SimpleReactLightbox>
                            <AdventureGallery
                                Adventure={Adventure}
                            />
                        </SimpleReactLightbox>
                        <div className="adventure-description" dangerouslySetInnerHTML={{ __html: Adventure.longDescription }}>
                        </div>
                        {/* {(Adventure.script.length > 0 && 
                            <InformationList title="Roteiro">
                                <div className="adventure-script">
                                    <ul>
                                        {Adventure.script.map((s, index) => 
                                            <li key={index}>
                                                <span>{s.label}</span>
                                                {s.value}
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </InformationList>
                        )} */}
                        {(Adventure.packages.length > 0 && 
                            <InformationList title="Pacotes">
                                <div className="adventure-packages" ref={el => this.package = el}>
                                    {
                                        RequestStore.loadingPackages ?
                                        "Carregando pacotes..."
                                        :
                                        Adventure.packages.map((p, index) => {
                                            return (
                                                <div key={index} className="package">
                                                    <Grid className="package-header" onClick={() => this.handleTogglePackage(p.pkPackage)}>
                                                        <GridItem className="package-title" lg={8} md={8} sm={6} xs={6}>
                                                            {p.name}
                                                        </GridItem>
                                                        <GridItem className="package-price" lg={4} md={4} sm={6} xs={6}>
                                                            <div>
                                                                R$ <NumberFormat className="package-number" value={(p.priceWithDiscount) ? p.priceWithDiscount : p.price}/><span></span>
                                                            </div>
                                                        </GridItem>
                                                    </Grid>
                                                    <div className={"package-content " + (packagesOpened.includes(p.pkPackage) ? "opened" : '')}>
                                                        {p.description.split("\n").map(text => <p>{text}</p>)}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                    
                                </div>
                            </InformationList>
                        )}
                        <InformationList opened={localizationOpened} title="Localização" onClick={() => this.setState({
                            localizationOpened: !localizationOpened
                        })}>
                            <div ref={el => this.map = el}>
                                <Tabs
                                    defaultActiveKey="1"
                                    onChange={this.onChangeTab}
                                    renderTabBar={()=><ScrollableInkTabBar />}
                                    renderTabContent={()=><TabContent />}
                                >
                                    <TabPane tab='MAPA' key="1">
                                        <div className="adventure-localization">
                                            {this.state.loadMapa && <div style={{height: `100%`}}>
                                                    <GoogleMaps
                                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBHN0W3GT8wkiI3JO8XmD-ZaG-joTURXs0&v=3.exp&libraries=geometry,drawing,places"
                                                    loadingElement={
                                                        <div style={{height: `100%`}}/>
                                                    }
                                                    containerElement={
                                                        <div style={{height: `100%`}}/>
                                                    }
                                                    mapElement={
                                                        <div style={{height: `100%`}}/>
                                                    }
                                                    defaultCenter={{
                                                        lat: parseFloat(Adventure.lat),
                                                        lng: parseFloat(Adventure.lng)
                                                    }}
                                                    circle={{
                                                        defaultCenter: {
                                                            lat: parseFloat(Adventure.lat),
                                                            lng: parseFloat(Adventure.lng),
                                                        },
                                                        center: {
                                                            lat: parseFloat(Adventure.lat),
                                                            lng: parseFloat(Adventure.lng),
                                                        },
                                                        position: {
                                                            lat: parseFloat(Adventure.lat),
                                                            lng: parseFloat(Adventure.lng),
                                                        },
                                                        defaultRadius: 800
                                                    }}
                                                />
                                            </div>}
                                        </div>
                                        <p><a className="maps-link" target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${Adventure.lat},${Adventure.lng}`}>Ver no Google Maps</a></p>
                                    </TabPane>
                                    {(!Adventure.same_locale_and_meeting_point && Adventure.meeting_point_lat && Adventure.meeting_point_lng &&
                                        <TabPane tab='PONTO DE ENCONTRO' key="2">
                                            <div className="adventure-localization">
                                                {this.state.loadMapa && <div style={{height: `100%`}}>
                                                        <GoogleMaps
                                                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBHN0W3GT8wkiI3JO8XmD-ZaG-joTURXs0&v=3.exp&libraries=geometry,drawing,places"
                                                            loadingElement={
                                                                <div style={{height: `100%`}}/>
                                                            }
                                                            containerElement={
                                                                <div style={{height: `100%`}}/>
                                                            }
                                                            mapElement={
                                                                <div style={{height: `100%`}}/>
                                                            }
                                                            defaultCenter={{
                                                                lat: parseFloat(Adventure.meeting_point_lat),
                                                                lng: parseFloat(Adventure.meeting_point_lng)
                                                            }}
                                                            circle={{
                                                                defaultCenter: {
                                                                    lat: parseFloat(Adventure.meeting_point_lat),
                                                                    lng: parseFloat(Adventure.meeting_point_lng),
                                                                },
                                                                center: {
                                                                    lat: parseFloat(Adventure.meeting_point_lat),
                                                                    lng: parseFloat(Adventure.meeting_point_lng),
                                                                },
                                                                position: {
                                                                    lat: parseFloat(Adventure.meeting_point_lat),
                                                                    lng: parseFloat(Adventure.meeting_point_lng),
                                                                },
                                                                defaultRadius: 800
                                                            }}
                                                        />
                                                </div>}
                                            </div>
                                            <p><a className="maps-link" target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${Adventure.meeting_point_lat},${Adventure.meeting_point_lng}`}>Ver no Google Maps</a></p>
                                        </TabPane>
                                    )} 
                                </Tabs>
                            </div>
                        </InformationList>
                        {(Adventure.frequentlyQuestion.length > 0 && 
                            <InformationList opened={this.state.faqOpened} title="Dúvidas Frequentes" onClick={() => this.setState({
                                faqOpened: !this.state.faqOpened
                            })}>
                                <div className="adventure-information-text">
                                    {Adventure.frequentlyQuestion.map((fq, index) => 
                                        <div className="faq" key={index}>
                                            <div className="faq-question">
                                                {fq.question}
                                            </div>
                                            <div className="faq-answer">
                                                {fq.answer}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </InformationList>
                        )}
                        {Adventure.comments.length > 0 &&
                            <div className="adventure-comments">
                                <div className="comment-head">
                                    {(Adventure.peopleWhoDidTheAdventure > 5 && 
                                        <div className="title">
                                            {Adventure.peopleWhoDidTheAdventure} pessoas já fizeram essa aventura
                                        </div>
                                    )}
                                    <div className="avaliation">
                                        <StarRatingComponent 
                                            name="rate2" 
                                            starCount={5}
                                            value={Adventure.stars}
                                            edditable={false}
                                            renderStarIcon={(index, value) => {
                                                    return <span className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />;
                                                    }}
                                            renderStarIconHalf={() => <span className="fa fa-star-half-full" />}
                                            />
                                    </div>
                                </div>
                                {Adventure.comments.slice(0, 5).map((c, index) => {
                                    return (
                                        <div className="comment" key={index}>
                                            <Grid>
                                                <GridItem lg={12} md={12} sm={12} xs={12}>
                                                    <div className="profile-head">
                                                        <div className="name">
                                                            {c.user.name}
                                                        </div>
                                                        <div className="box-stars">
                                                            <StarRatingComponent 
                                                                name="rate2" 
                                                                editing
                                                                starCount={5}
                                                                value={c.stars}
                                                                edditable={false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="date">
                                                        {this.getCommentDateFormat(c.created_at)}
                                                    </div>
                                                    <div className="description">
                                                        {c.description}
                                                    </div>
                                                </GridItem>
                                            </Grid>
                                        </div>
                                    );
                                })}
                            </div>
                        }
                    </div>
                    <div id="grid-payment" className="Grid-cell grid-payment relative">
                        <Checkout
                            focusOnAdventureInfo={this.handleGoTo}
                            noRequestFound={this.props.noRequestFound}
                            token={this.props.token}
                            goToPayment={params => this.props.goToPayment(params)}
                            goToIGo={(token, params) => this.props.goToIGo(token, params)}
                            Adventure={this.props.Adventure}
                        />
                    </div>
                </div>
            )
        } else {
            return (<div></div>);
        }

    }
}

const InformationList = ({opened = true, title, children, onClick = () => {}}) => {
    return (
        <div className="InformationList">
            <div className="header" onClick={onClick}>
                <div className="title">
                    {title}
                    {(onClick && <span className={"icon" + (opened && " icon-minus ") + (!opened && " icon-plus")}/>)}
                </div>
            </div>
            <div className={"content " + (opened && "opened")}>
                {children}
            </div>
        </div>
    )
}

export default AdventureInfos;